import { RunAutoScriptsDocument } from "generated/graphql";
import { runGqlMutation } from "gqlClient";
import { useSnackbar } from "notistack";
import { useCallback, useContext } from "react";
import { setCaseInsightsPending } from "redux/slices/case";
import { useAppDispatch } from "redux/hooks";
import { CaseFormContext } from "contexts/CaseFormContext";

export function useRunAutoScripts(caseId: number): () => Promise<void> {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const caseFormCtx = useContext(CaseFormContext);

  const runAutoScripts = useCallback(async () => {
    try {
      const res = await runGqlMutation(RunAutoScriptsDocument, { caseId });
      dispatch(setCaseInsightsPending(true));
      caseFormCtx.autoScriptRunIdsSet.add(res.case.runAutoScripts);
    } catch (e) {
      console.error(e);
      enqueueSnackbar("Case Insights refresh failed", { variant: "error" });
    }
  }, [caseId]);

  return runAutoScripts;
}
